<template>
    <div class="product4">
      <!--banner-->
      <div class="bannerBox">
        <div class="banner">
          <div class="mainContainer">
            <p class="titleBig gw_fadeInUp gw_animateDelay_01">牛盾云</p>
            <p class="gw_fadeInUp gw_animateDelay_02">安全稳定、高性能、低成本；提供多种服务套餐满足不同业务需求。 稳定、安全、弹性、高性能的云端计算服务，实时满足您的多样性业务需求。</p>
            <!--<button class="btns btns_detail"></button>-->
            <a class="btns btns_detail flex_center" href="//wpa.qq.com/msgrd?v=3&amp;uin=406669600&amp;site=qq&amp;menu=yes" target="_blank"><span>联系我们</span></a>
          </div>
        </div>
      </div>
      <!--产品优势-->
      <div class="mainContainer part1">
        <p class="title">产品优势</p>
        <div class="box_wrap flex_around">
          <div class="box">
            <div class="icon"><i></i></div>
            <p>稳定可靠</p>
            <div class="cons gw_fadeInUp gw_animateDelay_03">
              采用集中式的平台化管理，实现CPU/内存99.95%的服务可用性和不低于99.9999999%的数据可靠性。网络架构稳定，云硬盘多副本容灾，同时提供镜像及数据盘的快照功能，支持整机备份。
            </div>
          </div>
          <div class="box box2">
            <div class="icon"><i></i></div>
            <p>安全防护</p>
            <div class="cons gw_fadeInUp gw_animateDelay_03">
              用户间网络100%隔离，实时监控主机安全风险，精准防御黑客入侵行为，保障用户数据安全。提供完善的安全组及DDoS防护等服务，增强网络防御能力，为主机提供全面防护。
            </div>
          </div>
          <div class="box box3">
            <div class="icon"><i></i></div>
            <p>简单易用</p>
            <div class="cons gw_fadeInUp gw_animateDelay_03">
              提供简单易用的管理控制台和功能完备的API，支持秒级重启，缩短业务中断时长。支持使用镜像快速生成相同环境配置及应用部署的云主机，提升运维效率。
            </div>
          </div>
          <div class="box box4">
            <div class="icon"><i></i></div>
            <p>高性价比</p>
            <div class="cons gw_fadeInUp gw_animateDelay_03">
              云主机及相关计算资源均支持包年包月或按配置计费，按需购买，随时调整，无需投入硬件及运维成本。您可以根据使用场景灵活选择，切实为您实现成本优化需求。
            </div>
          </div>
        </div>
      </div>
      <!--应用场景-->
      <div class="container_bg">
        <div class="mainContainer part2">
           <p class="title">应用场景</p>
           <el-tabs v-model="activeName">
             <el-tab-pane label="企业型" name="first">
               <div class="tab_wrap flex_between">
                 <div class="tab_left">
                    <p>适用业务</p>
                    <div>企业官网，小型数据库等</div>
                    <p>使用建议</p>
                    <div>对 CPU、内存、带宽等无特殊要求的 Web 服务、应用程序、数据库等业务，只需要部署在一台服务器或者少量的几台服务器上。随着后续业务的增长，您可以对服务器的配置进行扩展。</div>
                 </div>
                 <div class="tab_right">
                   <div class="bg">
                     <p>推荐配置</p>
                     <div>CPU 4核</div>
                     <div>内存 8G</div>
                     <div>硬盘 200G</div>
                     <div><span>带宽 20M</span><span class="buy_btn"><a href="//wpa.qq.com/msgrd?v=3&amp;uin=406669600&amp;site=qq&amp;menu=yes" target="_blank">了解详情</a> ></span></div>
                   </div>
                 </div>
               </div>
             </el-tab-pane>
             <el-tab-pane label="专业型" name="second">
               <div class="tab_wrap flex_between">
                 <div class="tab_left">
                   <p>适用业务</p>
                   <div>页面上含有较多图像/视频的网站、应用</div>
                   <p>使用建议</p>
                   <div>使用牛盾云来托管含有大量图片和视频的网站、应用；使用牛盾云COS来实现大容量数据的低成本存储；使用负载均衡服务和内容分发网络来提高可用性，降低延时和带宽成本。</div>
                 </div>
                 <div class="tab_right">
                   <div class="bg">
                     <p>推荐配置</p>
                     <div>CPU 8核</div>
                     <div>内存 16G</div>
                     <div>硬盘 200G</div>
                     <div><span>带宽 50M</span><span class="buy_btn"><a href="//wpa.qq.com/msgrd?v=3&amp;uin=406669600&amp;site=qq&amp;menu=yes" target="_blank">了解详情</a> ></span></div>
                   </div>
                 </div>
               </div>
             </el-tab-pane>
             <el-tab-pane label="高IO型" name="third">
               <div class="tab_wrap flex_between">
                 <div class="tab_left">
                   <p>适用业务</p>
                   <div>生物制药，基因工程等</div>
                   <p>使用建议</p>
                   <div>多台自定义配置的计算型云服务器。</div>
                 </div>
                 <div class="tab_right">
                   <div class="bg">
                     <p>推荐配置</p>
                     <div>CPU 16核</div>
                     <div>内存 16G</div>
                     <div>硬盘 500G</div>
                     <div><span>带宽 100M</span><span class="buy_btn"><a href="//wpa.qq.com/msgrd?v=3&amp;uin=406669600&amp;site=qq&amp;menu=yes" target="_blank">了解详情</a> ></span></div>
                   </div>
                 </div>
               </div>
             </el-tab-pane>
             <el-tab-pane label="高计算" name="forth">
               <div class="tab_wrap flex_between">
                 <div class="tab_left">
                   <p>适用业务</p>
                   <div>企业官网，小型数据库等</div>
                   <p>使用建议</p>
                   <div>对 CPU、内存、带宽等无特殊要求的 Web 服务、应用程序、数据库等业务，只需要部署在一台服务器或者少量的几台服务器上。随着后续业务的增长，您可以对服务器的配置进行扩展。</div>
                 </div>
                 <div class="tab_right">
                   <div class="bg">
                     <p>推荐配置</p>
                     <div>CPU 18核</div>
                     <div>内存 16G</div>
                     <div>硬盘 500G</div>
                     <div><span>带宽 100M</span><span class="buy_btn"><a href="//wpa.qq.com/msgrd?v=3&amp;uin=406669600&amp;site=qq&amp;menu=yes" target="_blank">了解详情</a> ></span></div>
                   </div>
                 </div>
               </div>
             </el-tab-pane>
           </el-tabs>
        </div>
      </div>
      <!--产品定价-->
      <div class="mainContainer part3">
        <p class="title">产品定价</p>
        <div class="title_detail">包年最高可享83折优惠</div>
        <table border="1" width="100%">
          <thead>
           <tr>
             <th>套餐</th>
             <th>CPU</th>
             <th>内存</th>
             <th>硬盘</th>
             <th>宽带</th>
             <th>提供防御</th>
             <th>月付</th>
             <th>季付 <i></i><span>89折</span></th>
             <th>年付 <i></i><span>89折</span></th>
             <th>操作</th>
           </tr>
          </thead>
          <tbody>
            <tr>
              <td v-for="item in tableData.tr1" :key="item.id">{{item.value}}</td>
              <td class="buy_btn"><a href="//wpa.qq.com/msgrd?v=3&amp;uin=406669600&amp;site=qq&amp;menu=yes" target="_blank"><button class="btns">了解详情</button></a></td>
            </tr>
            <tr>
              <td v-for="item in tableData.tr2" :key="item.id">{{item.value}}</td>
              <td class="buy_btn"><a href="//wpa.qq.com/msgrd?v=3&amp;uin=406669600&amp;site=qq&amp;menu=yes" target="_blank"><button class="btns">了解详情</button></a></td>
            </tr>
            <tr>
              <td v-for="item in tableData.tr3" :key="item.id">{{item.value}}</td>
              <td class="buy_btn"><a href="//wpa.qq.com/msgrd?v=3&amp;uin=406669600&amp;site=qq&amp;menu=yes" target="_blank"><button class="btns">了解详情</button></a></td>
            </tr>
            <tr>
              <td v-for="item in tableData.tr4" :key="item.id">{{item.value}}</td>
              <td class="buy_btn"><a href="//wpa.qq.com/msgrd?v=3&amp;uin=406669600&amp;site=qq&amp;menu=yes" target="_blank"><button class="btns">了解详情</button></a></td>
            </tr>
          </tbody>
        </table>
        <p class="comment">带宽每增加10M，200元/月；硬盘每增加50G，50元/月</p>
      </div>
      <div class="gw_homefooterBox">
        <footBar></footBar>
      </div>
      <!--返回顶部-->
      <returnTop></returnTop>
    </div>
</template>

<script>
    import footBar from '../../components/footerbar';
    import returnTop from '../../components/returnTop'
    export default {
      name: "product4",
      data(){
        return{
          activeName:'first',
          tableData:{
             tr1:[{id:0,value:'A'},{id:1,value:'4核'},{id:2,value:'8G'},{id:3,value:'200G'},{id:4,value:'20M'},{id:5,value:'40G'},{id:6,value:'￥1400'},{id:7,value:'￥3750'},{id:8,value:'￥14000'}],
            tr2:[{id:0,value:'B'},{id:1,value:'8核'},{id:2,value:'16G'},{id:3,value:'200G'},{id:4,value:'50M'},{id:5,value:'60G'},{id:6,value:'￥2000'},{id:7,value:'￥5400'},{id:8,value:'￥20000'}],
            tr3:[{id:0,value:'C'},{id:1,value:'16核'},{id:2,value:'16G'},{id:3,value:'500G'},{id:4,value:'100M'},{id:5,value:'100G'},{id:6,value:'￥3000'},{id:7,value:'￥8250'},{id:8,value:'￥30000'}],
            tr4:[{id:0,value:'D'},{id:1,value:'18核'},{id:2,value:'16G'},{id:3,value:'500G'},{id:4,value:'100M'},{id:5,value:'无限量'},{id:6,value:'￥30000'},{id:7,value:'￥80000'},{id:8,value:'￥300000'}],
          }
        }
      },
      components:{
        footBar,returnTop
      },
      methods: {
      }
    }
</script>

<style scoped lang="scss">
  .product4{
    .bannerBox{
      .banner{
        background:url("../../assets/img/product4/banner.jpg") no-repeat center;
        background-size:cover;
        .mainContainer{
          .gw_animateDelay_02{
            width:599px;
          }
        }
        .btns_detail{
          text-decoration: none;
          span{
            font-size:20px;
            color:#fff;
            font-family: 'pingfangBold';
          }
        }
      }
    }
    .part1{
      padding-bottom:50px;
    }
    .part2,.part3{
      padding-top:50px;
    }
    .mainContainer{
      .title{
        font-family: 'pingfangBold';
        font-size: 24px;
        color: #272727;
        margin:0 0 35px;
      }
      .box_wrap{
        .box{
          width:269px;
          height:290px;
          border: 1px solid #E9E9E9;
          box-sizing: border-box;
          padding:26px 21px 0;
          p{
            font-size: 16px;
            color: #000000;
            margin-top:25px;
            margin-bottom:20px;
          }
          .icon{
            i{
              display: inline-block;
              width:36px;
              height:46px;
              background:url("../../assets/img/product4/product4_1.png") no-repeat center;
              background-size:100% 100%;
            }
          }
          .cons{
            text-align: left;
            font-size: 14px;
            color: #4A4A4A;
          }
        }
        .box2{
          .icon{
            i{
              width:40px;
              height:47px;
              background:url("../../assets/img/product4/product4_2.png") no-repeat center;
              background-size:100% 100%;
            }
          }
        }
        .box3{
          .icon{
            i{
              width:42px;
              height:46px;
              background:url("../../assets/img/product4/product4_3.png") no-repeat center;
              background-size:100% 100%;
            }
          }
        }
        .box4{
          .icon{
            i{
              width:49px;
              height:46px;
              background:url("../../assets/img/product4/product4_4.png") no-repeat center;
              background-size:100% 100%;
            }
          }
        }
      }
    }
    /*应用场景*/
    .container_bg{
      background: #FAFAFA;
      .tab_wrap{
        padding:25px;
        box-sizing: border-box;
        height:220px;
        .tab_left{
          width:840px;
          text-align: left;
          p{
            font-size: 16px;
            color: #000000;
            margin-bottom:10px;
          }
          div{
            font-size: 16px;
            color: #4A4A4A;
            margin-bottom:20px;
          }
        }
        .tab_right{
          .bg{
            width:250px;
            height:153px;
            background:url("../../assets/img/product4/part2.png") no-repeat center;
            background-size:100% 100%;
            box-sizing: border-box;
            padding:10px 25px;
            p,div{
              color:#fff;
            }
            p{
              font-size:16px;
              position:relative;
              &:before,&:after{
                width:60px;
                height:1px;
                background:#fff;
                position:absolute;
                top:50%;
                content:'';
              }
              &:before{
                left:0%;
              }
              &:after{
                right:0%;
              }
            }
            div{
              font-size:14px;
              text-align: left;
              margin-top:5px;
              .buy_btn{
                float:right;
                cursor:pointer;
                a{
                  font-size:14px;
                  color:#fff;
                  text-decoration: none;
                }
              }
            }
          }
        }
      }
    }
    /*产品定价*/
    .part3{
      padding-bottom:30px;
      .title{
        margin-bottom:6px !important;
      }
      .title_detail{
        position:relative;
        font-size: 14px;
        color: #4A4A4A;
        margin-bottom:10px;
        &:before,&:after{
          content:'';
          background:#4A4A4A;
          height:1px;
          position:absolute;
          top:52%;
          width:45px;
        }
        &:before{
          left:39%;
        }
        &:after{
          right:39%;
        }
      }
      table{
        border-collapse: collapse;
        border:1px solid #E9E9E9;
        thead{
          tr{
            height:50px;
            background: #F5F5F5;
            th{
              font-size: 14px;
              color: #4A4A4A;
              font-weight: normal;
              i{
                display: inline-block;
                width:13px;
                height:17px;
                background:url("../../assets/img/product4/fire.gif") no-repeat center;
                background-size:100% 100%;
                vertical-align: middle;
                margin-right:3px;
              }
              span{
                font-size: 12px;
                color: #F82732;
              }
            }
          }
        }
        tbody{
          tr{
            height:50px;
            td{
              font-size: 14px;
              color: #4A4A4A;
            }
            &:nth-child(2n){
              background: #FAFAFA;
            }
          }
        }
        .buy_btn{
          .btns{
            width:96px;
            height:28px;
            background: #2F87FF;
            font-size: 12px;
          }
        }
      }
      .comment{
        font-size: 14px;
        color: #9B9B9B;
        text-align: left;
        margin-top:15px;
      }
    }
    .gw_homefooterBox{
      height:160px;
    }
  }
  .container_bg /deep/ .part2{
    .el-tabs__nav-scroll{
      display: flex;
      justify-content: center;
    }
    .el-tabs__item{
      font-size:16px;
      color:#000;
      padding:0 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/product/product4.vue